<template>
    <div class="detail">
        <a :href="job.skipUrl">
            <div class="content" v-on:click="addMixPanel">
                  <img v-if="job.channel === 'ZipRecruiter'" 
                    :src="icons[2].src" 
                    :alt="icons[2].alt"
                    class="data-origin"
                  />
                <h2>{{ job.title }}</h2>
                <div class="job-tags">
                  <span v-if="job.tagOne">{{job.tagOne}}</span>
                  <span v-if="job.tagTwo">{{job.tagTwo}}</span>
                  <span v-if="job.tagThree">{{job.tagThree}}</span>
                  <span v-if="job.tagFour">{{job.tagFour}}</span>
                  <span v-if="job.tagFive">{{job.tagFive}}</span>
                  <span v-if="job.tagSix">{{job.tagSix}}</span>
                  <span v-if="job.tagSeven">{{job.tagSeven}}</span>
                </div>
                <div class="bottom">
                    <div class="company-info">
                        <img class="company-logo" :src="icons[0].src" :alt="icons[0].alt"/>
                        <span class="company-name">{{job.company}}</span>
                    </div>
                    <button type="primary" class="apply-job" v-on:click.stop=appJob>
                        Apply Now
                    </button>
                </div>
                <div class="job-location">
                    <img class="company-loc" :src="icons[1].src" :alt="icons[1].alt"/>
                    <span>{{job.city}},</span>
                    <span>{{job.state | mapToState}},</span>
                    <span>{{job.country}}</span>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
  import mixpanel from '@/utils/mixpanel.js'
  import {stateOptions} from '@/utils/state-options.js'
  export default {
    props: {
      job: {
        type: Object,
        default: () => {
        }
      },
      applyNow: {
        type: Boolean,
        default: false
      },
      source: {
        type: String,
        default: ''
      },
      width: {
        type: [String, Number],
        default: 686
      },
      height: {
        type: [String, Number],
        default: 517
      }
    },
    data() {
      return {
        loading: false,
        icons: [
          {
            src: require('@/assets/icon/img_company.svg'),
            alt: 'img_company'
          },
          {
            src: require('@/assets/icon/ic_map.svg'),
            alt: 'ic-map'
          },
          {
            src: require('@/assets/images/job-board/ziprecruiter.png'),
            alt: 'ziprecruiter'
          },
        ]
      }
    },
    methods: {
      addMixPanel() {
        const job = this.job;
        mixpanel.track('Job Board Page', {
          'Job': job.jobId,
          'Outcome': 'Click on job list',
        });
      },
      appJob() {
        const job = this.job;
        mixpanel.track('Job Board Page', {
          'Job': job.jobId,
          'Outcome': 'Click on Apply on job list'
        });
      },
    },
    filters: {
      mapToState(value) {
        return stateOptions.find(elem => elem.value === value).value
      }
    },
  }
</script>

<style lang="scss" scoped>
@font-face {
    font-family: SFProText-Bold;
    src: url(../../../assets/fonts/SF-Pro-Text-Bold.otf);
}

@font-face {
    font-family: SFProText-Regular;
    src: url(../../../assets/fonts/SF-Pro-Text-Regular.otf);
}
    .detail {
        position: relative;
        + .detail {
            margin-top: 5px;
        }
        .content {
            background-color: #fff;
            padding: 24px 15px 50px 20px;
            margin-bottom: 2px;
            position: relative;
            .data-origin {
              background-color: rgb(246, 247, 250);
              position: absolute;
              top: 0;
              right: 0;
              padding: 5px 8px 5px 5px;
              width: 62px;
            }
            h2 {
                font-family: SFProText-Bold;
                font-size: 16px;
                color: #141A42;
                font-weight: bold;
                letter-spacing: 0;
            }
            .job-tags {
              margin-top: 10px;
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              span {
                display: inline-block;
                font-family: SFProText-Regular;
                color: #141A42;
                padding: 0 10px;
                font-size: 12px;
                border-radius: 2px;
                padding: 4px;
                border: none;
                margin-right: 8px;
                background-color: rgb(246, 247, 250);
              }
            }
            .line {
                margin-top: 8px;
                font-size: 12px;
                line-height: 14px;
                opacity: 0.8;
                color: #141A42;

                span {
                    display: inline-block;
                    padding: 4px;
                    background-color: rgb(246, 247, 250);
                    margin-right: 8px;
                    font-family: SFProText-Regular;
                }
            }
            .bottom {
                margin-top: 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                .company-info {
                    display: flex;
                    align-items: center;
                    .company-logo {
                        width: 40px !important;
                        height: 30px !important;
                    }
                    .company-name {
                        margin-left: 5px;
                        font-size: 12px;
                        line-height: 14px;
                        color: rgb(114, 118, 142);
                        font-family: SFProText-Regular;
                        width: 200px;
                        overflow: hidden;/*超出部分隐藏*/
                        white-space: nowrap;/*不换行*/
                        text-overflow:ellipsis;/*超出部分文字以...显示*/
                    }
                }
                .apply-job {
                  border: 0;
                  width: 110px;
                  height: 32px;
                  border-radius: 2px;
                  font-size: 14px;
                  background-color: #168cd8 !important;
                  color: #fff;
                  float: right;
                  font-family: SFProText-Bold;
                  padding: 0 !important;
                  &.is-applied {
                      background-color: #f2f2f2;
                      color: rgba(50, 60, 80, 0.5);
                  }
                }
            }
            .job-location {
                background-color: rgb(246, 247, 250);
                display: flex;
                padding: 5px 15px;
                justify-content: flex-start;
                align-items: center;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                span {
                    font-size: 14px;
                    line-height: 14px;
                    color: rgb(67, 72, 104);
                    font-family: SFProText-Regular;
                    display: inline-block;
                    margin-right: 5px;
                }
                img {
                    width: 24px !important;
                    height: 24px !important;
                    margin-right: 5px;
                }
            }
        }
    }
</style>
